import InsertDriveFileOutlinedIcon from "@material-ui/icons/InsertDriveFileOutlined"
import React, {useMemo} from "react"
import {useDropzone} from "react-dropzone"
import {primary} from "../../helpers/theme"
import {useTranslation} from "react-i18next"

const baseStyle = {
  flex: 1,
  display: "flex",
  minHeight: 180,
  flexDirection: "column",
  justifyContent: "center",
  alignContent: "center",
  alignItems: "center",
  padding: "20px",
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#eeeeee",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out"
}

const focusedStyle = {
  borderColor: "#2196f3"
}

const acceptStyle = {
  borderColor: "#00e676"
}

const rejectStyle = {
  borderColor: "#ff1744"
}

export function DragDropFile({
  handleFiles,
  loading,
  renderStatusText,
  allowedFileTypes
}) {
  const {t} = useTranslation()
  const formatedAllowedFileTypes = () => {
    const obj = {}

    for (const key of allowedFileTypes) {
      obj[key.value] = [`.${key.label}`]
    }
    return obj
  }

  const {
    acceptedFiles,
    getRootProps,
    getInputProps,
    isFocused,
    isDragAccept,
    isDragReject
  } = useDropzone({
    accept: formatedAllowedFileTypes(),
    multiple: true,
    onDrop: files => files.map(file => handleFiles(file))
  })

  const acceptedFileItems = acceptedFiles.map(file => (
    <div
      style={{
        paddingTop: 20,
        fontSize: 16,
        color: primary,
        display: "flex",
        alignItems: "center"
      }}
      key={file.path}
    >
      <InsertDriveFileOutlinedIcon />{" "}
      <p style={{lineHeight: 1.8, marginLeft: 20}}>
        {file.path} {renderStatusText}
      </p>
    </div>
  ))

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {})
    }),
    [isFocused, isDragAccept, isDragReject]
  )

  return (
    <React.Fragment>
      <div className="container">
        <div {...getRootProps({style})}>
          <input {...getInputProps()} />
          {!!loading ? (
            loading
          ) : (
            <div
              style={{
                fontSize: 18,
                color: primary,
                display: "flex",
                alignContent: "center"
              }}
            >
              <p>
                {t("product.dnd.addFile")}{" "}
                {!!allowedFileTypes &&
                  !!allowedFileTypes.length &&
                  `(${allowedFileTypes.map(type => type.label).join(", ")})`}
              </p>
            </div>
          )}
        </div>

        {!!acceptedFileItems.length && <div>{acceptedFileItems}</div>}
      </div>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/forms/DragDropFile.js